/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getBasePricesV1 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'
import type { QueryHook, QueryHookOptions } from '@modules/query/types'

import { defaultBillingOptions } from './constants'

const useGetBasePrices: QueryHook<typeof getBasePricesV1> = (
  queryParameters: operations['getBasePricesV1']['parameters']['query'],
  options?: QueryHookOptions,
) =>
  useQuery(
    [`getBasePricesV1`, queryParameters?.product_family, queryParameters?.timestamp],
    () => getBasePricesV1({ queryParameters }),
    {
      ...defaultBillingOptions,
      ...options,
    },
  )

export default useGetBasePrices
